
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 500 500"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M319.3 46.9c-24.2 0-46.4 6-66.9 18l-.2.1c-19.9 11.5-35.9 27.3-48.1 48.1-11.3 19.9-17.1 41.7-17.1 66.1 0 14 2.2 27.7 6.8 41.3l4.6 13.7L45.5 387v66h94.7v-56.6h56.6v-56.7h55.3l29.3-33 13 2.4c8 1.5 16.2 2.3 24.9 2.3 36.9 0 67.5-12.6 93.2-38.3 26.3-26.3 39.2-57.3 39.2-94.1s-12.8-67.3-39-93l-.2-.1-.2-.2c-25.7-26-56.2-38.8-93-38.8zm-90.5-22.5C256.6 8.2 286.9 0 319.3 0c49.3 0 91.8 17.8 126.3 52.9 35.1 34.5 52.9 77 52.9 126.3s-17.8 92.2-52.9 127.2c-34.5 34.5-77.1 52-126.3 52-6.8 0-13.5-.4-20.1-1.1l-12.8 14.4c-8.7 9.9-20.6 15-33.5 15h-9.3v12c0 12-4.5 23-13.1 31.6-8.6 8.6-19.6 13.1-31.6 13.1h-12v12c0 12-4.5 23-13.1 31.6-8.6 8.6-19.6 13.1-31.6 13.1H43.1c-12 0-23-4.5-31.6-13.1-8.6-8.6-13.1-19.6-13.1-31.6v-69c0-12 4.5-23 13.1-31.6l133.7-133.7c-3.4-13.7-5.1-27.7-5.1-41.9 0-32.2 7.8-62.3 23.5-89.6l.1-.2c16.1-27.5 37.9-49.3 65.1-65zm86.3 65.7c12.7-12.7 28.7-19.3 46.7-19.3s34 6.5 46.7 19.3c12.7 12.7 19.3 28.7 19.3 46.7s-6.5 34-19.3 46.7c-12.8 12.7-28.7 19.3-46.7 19.3s-34-6.5-46.7-19.3c-12.7-12.7-19.3-28.7-19.3-46.7s6.6-34 19.3-46.7zm46.7 27.6c-5.7 0-9.7 1.7-13.5 5.5-3.8 3.8-5.5 7.9-5.5 13.5s1.7 9.7 5.5 13.5 7.9 5.5 13.5 5.5 9.7-1.7 13.5-5.5 5.5-7.9 5.5-13.5-1.7-9.7-5.5-13.5-7.9-5.5-13.5-5.5z"}})])
          )
        }
      }
    